


































import { Component, Prop } from "vue-property-decorator";
import { BaseComponent } from "@/app/BaseComponent";
import { InjectService } from "@fastoche/ui-core/di";
import { FileService } from "@/modules/file/services/FileService";
import { HlUserManagementPeriod } from "@leavy/lv-homesharing-backend-srv/lib/hl/domain/HlUserManagementPeriod";
import { HlUserAccommodation } from "@leavy/lv-homesharing-backend-srv/lib/hl/domain/HlUserAccommodation";
import { LvIcon } from "@fastoche/ui-kit";
import { hugeLocaleDate } from "@/app/filters/date";
import { price } from "@fastoche/ui-core/i18n/currency/filters";

export const COMPONENT_NAME = "HlUserManagementPeriodRowCard";

@Component({
    name: COMPONENT_NAME,
    components: {
        LvIcon
    },
    filters: {
        hugeLocaleDate,
        price
    }
})
export default class HlUserManagementPeriodRowCard extends BaseComponent {
    @InjectService(FileService)
    private readonly fileService!: FileService;

    @Prop({ type: Object, required: true })
    readonly period!: HlUserManagementPeriod;

    @Prop({ type: Object, required: true })
    readonly accommodation!: HlUserAccommodation;

    @Prop({ type: Boolean, required: false, default: false })
    readonly clickable!: boolean;

    private get cardClassList() {
        return [
            this.clickable ? "clickable" : null,
        ].filter(x => x != null) as string[];
    }

    private get coverPhoto() {
        const [firstPhoto] = this.accommodation.photos;
        if (!firstPhoto) return null;
        return this.fileService.getFileUrl(firstPhoto).url;
    }

    private onCardClick(ev: MouseEvent) {
        if (this.clickable) {
            this.$emit("click", ev);
        }
    }
}
